/**
 * FileName : nodeTree.ts
 * ProjectName : admin
 * Author : <<author>>
 * Created Date: 2024-10-24 16:22:28
 * Description :
 * -----
 * Last Modified: 2024-10-24 16:35:40
 * Modified By :
 * -----
 * Copyright (c) <<year>> <<company>>. All rights reserved.
 */

import { NodeByLoginUserData } from 'src/api/common/type';
import { CascaderData } from 'src/utils/function';

export type InitState = {
  nodeTree: NodeByLoginUserData[];
  nodeOpt: CascaderData[];
}

export const ADD_NODE = 'addNode';

export type Action = {
  type: typeof ADD_NODE;
  value: InitState;
}

const initState = {
    nodeTree: [],
    nodeOpt: [],
};

export const nodeTreeDispath = (state: InitState = initState, action:Action) => {
    switch (action.type) {
        case 'addNode':
            return { ...state, ...action.value };
        default:
            return state;
    }
};
